<template>
    <div class="container">
        <b-modal
            :model-value="modalEditar"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <!-- <pre>{{ infoCalificacion }}</pre> -->
                        <label>{{ labels.vigencia }}</label>
                        <p>{{ form.vigencia }}</p>

                        <label>{{ labels.calificacion }}</label>
                        <p>{{ form.calificacion }}</p>

                        <label>{{ labels.descripcion }}</label>
                        <b-form-input
                            v-model="form.descripcion"
                            type="text"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.score }}</label>
                        <b-form-input
                            v-model="form.score"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="guardarCalificacion()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Calificacion from '../../../services/Calificacion'; 

export default {
    name : 'Editar',
    props: {
        modalEditar: {
            type: Boolean,
            required: true
        },
        infoCalificacion: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            form : {
                calificacion : '',
                score : null,
                descripcion : '',
            },
            showCalificacion: false
        }
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Editar calificación',
                    vigencia : 'Vigencia',
                    score : 'Score',
                    descripcion : 'Descripción',
                    calificacion : 'Calificación',
                    save : 'Guardar',
                    close : 'Cerrar',
                    formInfoTitle : 'Datos de la calificación',
                    formInfoSubtitle: "Actualiza la información de la calificación y guarda los cambios."
                }
            }else{
                return {
                    title : 'Edit rating',
                    vigencia : 'Validity',
                    score : 'Score',
                    descripcion : 'Description',
                    calificacion : 'Rating',
                    save : 'Save',
                    close : 'Close',
                    formInfoTitle : 'Qualification details',
                    formInfoSubtitle: "Update the rating information and save the changes."
                }
            }
        }
    },
    methods:{
        guardarCalificacion(){

            if (!this.form.calificacion || !this.form.descripcion || !this.form.score) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }

            const info = {
                'id' : this.form.id, 
                'vigencia' : this.form.vigencia, 
                'calificacion' : this.form.calificacion, 
                'descripcion' : this.form.descripcion, 
                'score' : this.form.score, 
                'idUser' : this.$store.state.userId 
            }

            Calificacion.updateCalificacion(info) 
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("actualizado");
                    this.cierraModal(); 
                }
            })
            .catch((err) => { 
                if(err.response.status == 400){ 
                    this.$toast.error(err.response.data.message) 
                }
            })


            /*if(!this.showCalificacion){ 

                // console.log('UPDATE'); 
                Calificacion.updateCalificacion(this.infoCalificacion) 
                .then((res) => { 
                    if(res.status == 200){ 
                        this.$toast.success(res.data.message) 
                        location.reload() 
                    }
                })
                .catch((err) => { 
                    if(err.response.status == 400){ 
                        this.$toast.error(err.response.data.message) 
                    }
                })

            }else{
                // console.log('INSERT'); 
                let dataForm = [
                    this.infoCalificacion[0].vigencia, 
                    this.descripcion, 
                    this.calificacion 
                ]

                if(dataForm.includes('')){ 
                    this.$toast.error('Campo(s) pendiente(s) por diligenciar') 
                }else{
                    let info = {
                        'vigencia' : this.infoCalificacion[0].vigencia, 
                        'descripcion' : this.descripcion, 
                        'calificacion' : this.calificacion, 
                        'idUser' : this.$store.state.userId 
                    }

                    Calificacion.createCalificacion(info) 
                    .then((res) => { 
                        if(res.status == 201){ 
                            this.$toast.success(res.data.message) 
                            location.reload() 
                        }
                    })
                    .catch((err) => console.log(err)) 
                }
            }*/
        },
        cierraModal(){
            this.$emit('cierraModal',false) 
            this.showCalificacion = false 
        }
    },
    watch: {
        infoCalificacion: {
            immediate: true,
            deep: true,
            handler(value) {
                if (value) {
                    this.form = { ...value };
                }
            }
        }
    },
}
</script>

<style>

</style>
